import {
  CHANGE_USER_ACCOUNT,
  LOGOUT,
} from 'portal-modules/auth/redux/modules/user'

// action types
export const ADD_CUSTOM_CONTENT = 'rp/customContent/ADD_CUSTOM_CONTENT'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case ADD_CUSTOM_CONTENT:
      return { ...state, ...payload }
    case CHANGE_USER_ACCOUNT:
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
// payload = { [key]: "Custom text/content" }
export const addCustomContent = payload => ({
  type: ADD_CUSTOM_CONTENT,
  payload,
})
